import { ArrowUpRight } from "lucide-react";
import { Reveal, Chapter } from "@/components/site/Reveal";
import { VALUE_STATS } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export default function ValueProp() {
  return (
    <section id="why" className="relative bg-ink">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute left-1/2 top-0 h-[300px] w-[720px] -translate-x-1/2 rounded-full bg-gold/[0.06] blur-[130px]" />
      </div>
      <div className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
        <Chapter n="Chapter 08" label="Why VERIVISTA" dark />
        <Reveal>
          <h2 className="max-w-3xl text-balance font-serif text-3xl font-medium leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
            Producers keep creative control. <span className="italic text-gold">We keep financial control.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-px bg-white/10 lg:grid-cols-3">
          {VALUE_STATS.map((s, i) => (
            <Reveal key={s.value} delay={0.12 * i}>
              <div data-testid={`value-prop-card-${i + 1}`} className="group h-full bg-ink p-10 transition-colors duration-500 hover:bg-abyss">
                <p className="font-serif text-5xl font-medium text-gold sm:text-6xl">{s.value}</p>
                <p className="mt-5 max-w-xs text-sm leading-relaxed text-mist">{s.label}</p>
                <span className="mt-8 block h-px w-10 bg-gold/40 transition-all duration-500 group-hover:w-24 group-hover:bg-gold" aria-hidden="true" />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-20 flex flex-col items-start justify-between gap-10 border border-gold/25 bg-gradient-to-r from-abyss to-ink p-10 sm:p-14 lg:flex-row lg:items-center">
            <p className="max-w-2xl font-serif text-2xl font-medium italic leading-snug text-ivory sm:text-3xl">
              “The producer who sees the true number every week never loses control of the picture.”
            </p>
            <button
              data-testid="value-cta-button"
              onClick={() => scrollToId("#contact")}
              className="group flex shrink-0 items-center gap-3 bg-gold px-8 py-4 font-mono text-[11px] uppercase tracking-[0.22em] text-ink transition-colors duration-300 hover:bg-gold-bright"
            >
              Discuss Your Production
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
